import { css } from '@emotion/react';

export const flexChildrenV = css`
  display: flex;
  flex-direction: column;
`;
export const flexChildrenH = css`
  display: flex;
  flex-direction: row;
`;
export const flexStay = css`
  flex-grow: 0;
  flex-shrink: 0;
`;
export const flexAdapt = css`
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 0;
  overflow: hidden;
`;

export const backgroundStyles = (publicURL) => css`
    background-image: url("${publicURL}bg.png");
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: top;
    background-size: contain;
    background-color: #003467;
    `;

export const centerSelf = css`
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  position: relative;
`;

export const centerContent = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const centerContentVertically = css`
  display: flex;
  align-items: center;
`;
